import { useState, useCallback } from 'react';
import { Tier, PowerUpState, POWER_UP_ALLOWANCES } from '../types/game';

export function usePowerUps(tier: Tier) {
  const [remaining, setRemaining] = useState<PowerUpState>(() => ({
    ...POWER_UP_ALLOWANCES[tier],
  }));

  const activateFiftyFifty = useCallback((): boolean => {
    if (remaining.fiftyFifty <= 0) return false;
    setRemaining((prev) => ({ ...prev, fiftyFifty: prev.fiftyFifty - 1 }));
    return true;
  }, [remaining.fiftyFifty]);

  const activateTimeFreeze = useCallback((): boolean => {
    if (remaining.timeFreeze <= 0) return false;
    setRemaining((prev) => ({ ...prev, timeFreeze: prev.timeFreeze - 1 }));
    return true;
  }, [remaining.timeFreeze]);

  const activateSkip = useCallback((): boolean => {
    if (remaining.skip <= 0) return false;
    setRemaining((prev) => ({ ...prev, skip: prev.skip - 1 }));
    return true;
  }, [remaining.skip]);

  const reset = useCallback(() => {
    setRemaining({ ...POWER_UP_ALLOWANCES[tier] });
  }, [tier]);

  return { remaining, activateFiftyFifty, activateTimeFreeze, activateSkip, reset };
}
